<header class="header-auto buy">
    <div class="container-m">
      <div data-w-id="db389cc9-269c-e743-e738-c6b3ed48f248"  class="topline-wrapper b-30px c-center">
        <div class="text-topline">RENT properties</div>
        <div class="topline-line bg-primary c-center"></div>
      </div>
      <div class="content-wrapper">
        <h1 data-w-id="542638f5-32c7-7039-a6c2-406f90495f66"  class="h1 l-center">explore our properties for rent</h1>
      </div>
    </div>
    <div class="container-l"></div>
    <div class="bg-section bg-background"></div>
  </header>
  <section class="section standard">
    <div class="container-m">
      <div class="filter-section">
        <div data-w-id="ebf8d987-d5b1-e4a7-c94a-82f456e163d4"  class="filters-vertical">
          <div class="orga">
            <h3 class="h3">Filter</h3>
          </div>
          <div class="propertie-filter">
            <div class="filters-group filters-colors mb-normal">
              <a (click)="filterProperty('All')" class="sort-button btn-small w-inline-block">
                <div>All</div>
              </a>
              <a (click)="filterProperty('OffPlan')" class="sort-button off-plan btn-small w-inline-block">
                <div>Off-Plan</div>
              </a>
              <a (click)="filterProperty('Ready')" class="sort-button ready-properties btn-small w-inline-block">
                <div>Ready Properties</div>
              </a>
            </div>
            <div class="filters-group select-test">
              <div class="filter-form-select w-form">
                <select id="CMS-Select" name="CMS-Select" (change)="filterProperty('Category')" [(ngModel)]="selectedCategory" class="select w-select">
                  <option style="color: #fff;" [ngValue]="'All'">All</option>
                  <option style="color: #fff;" *ngFor="let c of categoryList" [ngValue]="c.name">{{c.name}}</option>
                </select>
                <div class="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="collection-list-wrapper t-40px w-dyn-list">
          <div role="list" class="collection-list filter-complex w-dyn-items">
            <div *ngFor="let property of propertyList" role="listitem" class="collection-list-item w-dyn-item">
              <a data-w-id="85de7378-ad14-8fe6-f649-6def91719cfc" [routerLink]="['/propertydetail', property.id]" class="collection-list-content w-inline-block">
                <div class="image-wrapper h-200px"><img src="{{property.propertyTitleImageUrl}}" loading="lazy" alt="" class="image full-screen">
                  <div class="tag bg-dark">
                    <div class="text-block text-background">NEW</div>
                  </div>
                </div>
                <div class="box status-normal">
                  <div class="orga">
                    <h5 class="h5 status-h">{{property?.propertyTitle}}</h5>
                    <p class="text-xsmall b-15px">{{property?.propertyLocationArea}}</p>
                  </div>
                  <div class="orga">
                    <div class="annual-wrapper">
                      <div class="status-price">{{property?.propertyPriceCurrency}} {{property?.propertyPrice}} ({{property?.rentPaymentMode}})</div>
                    </div>
                    <div class="line-status"></div>
                    <div class="properties-wrapper">
                      <div class="properties-content">
                        <div class="bedroom-wrapper">
                          <p class="text-details text-default w-dyn-bind-empty"></p>
                          <p class="text-details text-default l-5px">{{property?.bedroomCount}} Bedrooms</p>
                        </div>
                        <p class="text-details text-default">•</p>
                        <div class="bathroom-wrapper">
                          <p class="text-details text-default w-dyn-bind-empty"></p>
                          <p class="text-details text-default l-5px">{{property?.bathroomCount}} Bathrooms</p>
                        </div>
                      </div>
                      <div class="status-button l-10px">
                        <div class="stauts-icon"><img src="../../assets/images/Pfad-4727.svg" loading="lazy" width="10" alt="" class="sold-image"></div>
                        <div class="details-text">Details</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="filters-hide">
                  <div class="color w-dyn-bind-empty"></div>
                  <div class="services w-dyn-bind-empty"></div>
                </div>
              </a>
            </div>
          </div>
          <!-- <div class="empty-state w-dyn-empty">
            <div>No items found.</div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </section>
  <section class="section standard no-overflow">
    <div class="container-m">
      <div class="w-layout-grid grid _2er-c-left">
        <div id="w-node-_20cbce53-a35a-ba28-b095-be02bcb2b160-bcb2b15d" class="grid-item p1">
          <div class="content-wrapper">
            <div data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b162" class="topline-wrapper b-30px">
              <div class="topline-line bg-primary"></div>
              <div class="text-topline">COntact</div>
            </div>
            <h4 data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b166" class="h2"><strong>GET IN TOUCH </strong></h4>
            <p data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b168" class="text-normal max-75p">Contact our real estate experts to discuss your needs. Our team has the expertise to guide you through the entire process.<br></p>
            <div data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b16b" class="button-wrapper t-30px xs-vertical">
              <a [routerLink]="['/contact']" class="button button-primary r-25px w-button">contact us</a>
              <div class="button-wrapper-inner xs-l-20px">
                <a href="tel:+97145693115" class="button button-link w-button">+971 4 380 5710</a>
              </div>
            </div>
          </div>
        </div>
        <div id="w-node-_20cbce53-a35a-ba28-b095-be02bcb2b16e-bcb2b15d" class="grid-item">
          <div class="image-wrapper i-layers-left"><img src="../../assets/images/gs-3.svg" loading="lazy" width="876" data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b170" alt="" class="image i-layer-01 contact-01">
            <div data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b171" class="form-block-cta w-form">
              <!-- <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="615ea8ddc2e661e7c3a9928f" data-wf-element-id="20cbce53-a35a-ba28-b095-be02bcb2b172"> -->
                <h4 class="h-form text-background">Get the<br><span class="text-span">Newsletter</span></h4>
                <p class="text-normal text-background">Sign up to get the latest updates delivered right to your inbox.<br></p>
                <div class="text-field-wrapper t-20px"><input class="text-field w-input" maxlength="256" name="email-2" data-name="Email 2" placeholder="E-Mail-Address" type="email" id="email-2" required=""><input type="submit" data-wait="" class="submit-button w-button" value=""></div><label class="w-checkbox checkbox-label"><input type="checkbox" id="checkbox" name="checkbox" data-name="Checkbox" required="" class="w-checkbox-input checkbox-hudson"><span class="text-xsmall text-background w-form-label" for="checkbox">I agree to the Terms of Service and Privacy Policy</span></label>
              <!-- </form> -->
              <div class="form__success w-form-done">
                <div class="text-background">Thank you! Your submission has been received!</div>
              </div>
              <div class="error-message w-form-fail">
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-light"></div>
  </section>